<template>
  <v-content class>
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />
    <v-container
      v-if="proposal"
      fluid
      grid-list-xl
      id
      class="white-background proposta-header"
    >
      <v-layout row wrap>
        <v-flex :class="proposal.status == 'RECUSADA' ? 'xs12' : 'md6 sm12'">
          <h1
            class="proposta-title d-inline-block"
            v-if="proposal.status != EMITIDA_STATUS"
            v-html="`Nº ${$route.params.propostaId}`"
          />
          <h1
            class="proposta-title d-inline-block"
            v-if="proposal.status == EMITIDA_STATUS"
            v-html="`Nº ${proposal.id_apolice}`"
          />
          <br />
          <p
            v-if="proposal.status == EMITIDA_STATUS"
            v-html="proposal.mensagem"
          ></p>
          <p v-if="proposal.status == 'RECUSADA'" class="msg-erro">
            <v-icon>warning</v-icon>
            <span v-html="proposal.mensagem"></span>
          </p>

          <!-- <p class='proposta-date d-inline-block' v-html="formatDate(proposal.vencimento_primeira_parcela)" /> -->
        </v-flex>

        <v-flex
          :class="proposal.status == 'RECUSADA' ? 'xs12' : 'md6 sm12'"
          text-xs-right
        >
        <!--
          <v-btn
            class="jns-button white-button width-auto"
            @click="desistir()"
            v-if="
              !statusWhichDenyToGiveUpProposal.includes(proposal.status) &&
              !corretorAnalise
            "
            >Desistir</v-btn
          >
          -->
          <v-btn
            class="yellow-button jns-button width-auto"
            @click="
              $router.push({
                path: `/proposta/editar/${$route.params.propostaId}/${$route.params.produtoId}`,
              })
            "
            v-if="statusWhichAllowToEditProposal.includes(proposal.status)"
            >Prosseguir para Emissão</v-btn
          >

          <v-menu offset-y v-for="botao in botaoList" :key="botao.descricao">
            <v-btn class="white-button jns-button width-auto" slot="activator">
              <i class="mr-2 ml-0">{{ botao.icone }}</i>
              {{ botao.descricao }}
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="opcao in getBotaoOpcoes(botao.descricao)"
                :key="opcao.descricao"
                @click="
                  opcao.action
                    ? setActionOpcaoBotao(opcao.action)
                    : $router.push({
                        path: opcao.route,
                      })
                "
              >
                <v-list-tile-avatar>
                  <i class="mr-1 ml-0">{{ opcao.icone }}</i>
                </v-list-tile-avatar>
                <v-list-tile-title>
                  <p>{{ opcao.descricao }}</p>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="proposal" fluid grid-list-md>
      <document-tabs
        :current="tabIndex"
        :items="tabTexts"
        @change-tab="changeTab"
      />

      <v-layout row wrap class="proposta-content">
        <v-flex xs12>
          <document-information
            :acompanhamento="corretorAnalise"
            :proposal="proposal"
            :tab-index="tabIndex"
            @reanalysis="setTabReanalise"
          />
        </v-flex>
      </v-layout>

      <v-footer
        class="proposta__footer"
        v-if="
          !statusWhichDenyToGiveUpProposal.includes(proposal.status) &&
          tabIndex == 'Timeline' &&
          corretorAnalise
        "
      >
        <!--<v-flex class="xs6">  
          <v-btn class="jns-button white-button width-auto" @click="desistir()"
            >Desistir</v-btn
          >
        </v-flex>-->
        <v-flex class="xs6 pull-right">
          <v-btn
            class="jns-button yellow-button width-auto"
            @click="dialogQuestionamento = true"
            >Questinamento</v-btn
          >
        </v-flex>
      </v-footer>

      <!-- Modal Questinamento -->
      <questionamento-component
        :questionamentoDialog="dialogQuestionamento"
        :questionamentoSucessoDialog="questionamentoSucessoModal"
        @send="sendQuestionamento"
        @close="dialogQuestionamento = false"
      />

      <v-dialog
        v-model="showEndossoCancelamentoDialog"
        persistent
        :max-width="'1000'"
      >
        <base-modal>
          <endosso-cancelamento-component
            v-if="showEndossoCancelamentoDialog"
            :proposta="proposal"
            @fechar="showEndossoCancelamentoDialog = false"
          />
        </base-modal>
      </v-dialog>

      <v-dialog
        v-model="showEndossoCancelamentoManualDialog"
        max-width="auto"
        max-height="680"
      >
        <base-modal>
          <template
            v-if="params && params.conteudo && params.conteudo.url_formulario"
          >
            <iframe
              :src="params.conteudo.url_formulario"
              width="100%"
              height="610"
              frameborder="0"
            ></iframe>

            <v-layout row wrap>
              <v-flex offset-md10 md2 offset-sm6 sm6 pb-0>
                <button
                  class="button jns-button yellow-button"
                  @click="showEndossoCancelamentoManualDialog = false"
                >
                  Fechar
                </button>
              </v-flex>
            </v-layout>
          </template>

          <h2
            v-else
            class="title"
            v-html="'Não foi possível carregar o formulário'"
          ></h2>
        </base-modal>
      </v-dialog>

      <v-dialog v-model="errorModal" :max-width="'640'">
        <base-modal>
          <h2 class="title" v-html="error.title"></h2>
          <p class="description" v-html="error.message"></p>
          <v-layout row wrap>
            <v-flex xs4 offset-xs8>
              <button
                class="button jns-button yellow-button"
                @click="errorModal = false"
              >
                OK
              </button>
            </v-flex>
          </v-layout>
        </base-modal>
      </v-dialog>

      <!-- Modal desistência -->
      <!--
      <v-dialog v-model="modalDesistir" :max-width="'640'">
        <base-modal>
          <h2 class="title">Informe o motivo da desistência</h2>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                class="form-select-box"
                label="Motivo"
                v-model="id_motivo"
                placeholder="Motivo "
                :rules="[(v) => !!v || 'Este campo deve ser preenchido!']"
                :items="motivos"
                :item-value="'id'"
                :item-text="'descricao'"
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                label="Observações"
                v-model="observacao"
                class="input-group"
                outline
              ></v-textarea>
            </v-flex>

            <v-flex xs6>
              <v-btn
                class="button jns-button yellow-button"
                @click="quitProposal()"
                >OK</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                class="button jns-button yellow-button"
                @click="modalDesistir = false"
                >Cancelar</v-btn
              >
            </v-flex>
          </v-layout>
        </base-modal>
      </v-dialog>
      -->
      <!-- ./Modal desistência -->
    </v-container>
  </v-content>
</template>

<script lang="js">
import moment from "moment";
import ViewMixin from "@/mixins/ViewMixin";
import PropostaMixin, {
  STATUS_QUESTIONAMENTO_VALIDOS
} from "@/mixins/PropostaMixin";
import { mapActions } from "vuex";

export default {
  name: "DetalhesProposta",
  mixins: [ViewMixin, PropostaMixin],
  data: () => ({
    params: {},
    showEndossoCancelamentoManualDialog: false,
    showEndossoCancelamentoDialog: false,
    statusWhichAllowToEditProposal: ["CORRETOR_ANALISE_EMISSAO"],
    statusWhichAllowToPrintMinuta: [
      "SEGURADORA_ANALISE_EMISSAO",
      "CORRETOR_ANALISE_EMISSAO",
    ],
    statusWhichDenyToGiveUpProposal: ["EMITIDA", "CANCELADA", "RECUSADA"],
    tabTexts: ["Informações da Proposta"],
    motivos: [],
    documentosData: [],
    modalidades: [
      { text: "Modalidade 1" },
      { text: "Modalidade 2" },
      { text: "Modalidade 3" },
    ],
    questionamento: {
      body: {
        observacoes: "",
        documentos: [],
      },
    },
    error: {
      title: "",
      message: "",
    },
    proposal: false,
    timeline: false,
    dialogQuestionamento: false,
    corretorAnalise: false,
    modalDesistir: false,
    errorModal: false,
    questionamentoSucessoModal: false,
    observacao: "",
    tabIndex: "Informações da Proposta",
    EMITIDA_STATUS: "EMITIDA",
    id_motivo: 0,
  }),
  computed: {
    botaoList: function () {
      let botoes = [];
      if (
        this.statusWhichAllowToPrintMinuta.includes(this.proposal.status) ||
        this.proposal.status == this.EMITIDA_STATUS
      )
        botoes.push({ descricao: "Download", icone: "save_alt" });

      return botoes;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions([
      "GET_MINUTA",
      "GET_DOCUMENTO_APOLICE",
      "GET_BOLETO",
      "GET_PROPOSAL",
      "QUIT_PROPOSAL",
      "POST_QUESTIONAMENTO",
    ]),

    async init() {
      this.showLoadingIndicator();
      await this.getProposal(
        this.$route.params.propostaId,
        this.$route.params.produtoId
      );
      this.hideLoadingIndicator();
      this.deveMostrarQuestionamento();
      this.setActiveTab();
    },

    async getProposal(propostaId, produtoId) {
      let payload = {
        id_proposta: propostaId,
        id_produto: produtoId,
      };

      try {
        this.proposal = await this.GET_PROPOSAL(payload);
        const text = this.getProposalStatusText(this.proposal.status)
        text && this.tabTexts.push(text);
      } catch (e) {
        this.defaultHandlerError(e);
      }
    },

    changeTab($event) {
      this.tabIndex = $event.currentTarget.value;
    },

    editProposal() {
      this.$router.push({
        path: `/proposta/editar/${this.$route.params.propostaId}/${this.$route.params.produtoId}`,
      });
    },

    setTabReanalise() {
      const { status } = this.proposal;
      this.tabIndex = this.getProposalStatusText(status);
    },

    deveMostrarQuestionamento() {
      const { status } = this.proposal;
      this.corretorAnalise =
        STATUS_QUESTIONAMENTO_VALIDOS.indexOf(status) >= 0;
    },

    setShowEndossoCancelamentoDialog() {
      this.showEndossoCancelamentoDialog = true;
    },

    setActionOpcaoBotao(action) {
      this[action]();
    },

    setActiveTab() {
      if (
        location.href.lastIndexOf("credito") > 0 &&
        this.tabTexts.filter((tab) => tab == "Formulário de Crédito").length > 0
      )
        this.tabIndex = "Formulário de Crédito";
      else if (
        location.href.lastIndexOf("subscricao") > 0 &&
        this.tabTexts.filter((tab) => tab == "Analise de Subscrição").length > 0
      )
        this.tabIndex = "Analise de Subscrição";
      else if (
        location.href.lastIndexOf("resseguro") > 0 &&
        this.tabTexts.filter((tab) => tab == "Analise de Resseguro").length > 0
      )
        this.tabIndex = "Analise de Resseguro";
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .header_acoes {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .proposta-content-title {
    color: #4e4e4e;
    font-size: 18px;
    font-weight: bold;
  }
  .container-form {
    margin: 0;
    padding: 0;
    .white-background {
      margin: 0;
    }
  }
  .form-title {
    position: relative;
    h1 {
      padding: 10px;
      font-size: 22px;
      font-weight: bold;
      color: #4e4e4e;
      text-align: center;
    }
    i {
      position: absolute;
      top: 25px;
      left: 25px;
    }
  }
  .proposta__footer {
    margin-top: -47px;
  }

  .jns-button {
    text-transform: none;
    margin: 6px 12px;
  }
  .fluid-button {
    width: auto;
    padding-left: 30px;
    padding-right: 40px;
    transition: none;
    height: 50px;
    &.active {
      padding-right: 6px;
    }
  }
  .questionamento-dialog-button {
    width: 200px;
  }
  .jns-textarea {
    background: #eee;
  }
  .msg-erro,
  .msg-erro i {
    color: red !important;
    /*font-size: 12px;*/
    margin-right: 5px;
  }
}
.back-button {
  position: relative;
  padding-left: 30px;
  svg {
    position: absolute;
    margin-left: -30px;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    margin-top: -6px;
    margin-left: 6px;
    text-decoration: none;
    display: inline-block;
  }
}

.container {
  padding-bottom: 1vh;
}
.v-list__tile__title {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Propostas/Detalhar.vue